import React from "react";

const ConfirmPayRadio: React.FC<{ isSelected: boolean }> = ({ isSelected }) => (
  <img
    src={`/icons/confirm-pay/report_radio_${isSelected ? "on" : "off"}.svg`}
    alt=""
    aria-hidden
    className="h-6 w-6 shrink-0"
  />
);

export default ConfirmPayRadio;
